import React from "react";
import { Dialog } from "../dialog/dialog";
import { Button } from "../button/button";

import "./window.css";
import './hello-animation.css';
import { Hello } from "../hello/hello";
import { HelloText } from '../hello-text/hello-text';
import { GameMenu } from '../game-menu/game-menu';

export class Window extends React.Component {
  posibleStatusOfButton = ["wait", "success", "wrong"];

  constructor(props) {
    super(props);
    this.state = {
      one: "wait",
      two: "wait",
      three: "wait",
      police: false,
      started: false,
      startButtonStatus: "wait",
      dialogData: [{
        person: ["policeman", "you"],
        text: ["Предъявите ваши документы.", ""]
      }],
      gameNumber: 0
    };
  }

  componentDidMount() {
    setTimeout(() => {
      // document.getElementById("hello-text").style.display = "block";
      document.getElementById('hello').style.display = 'none';
      document.getElementById("hello-video").play();
      
    }, 2000)
  }

  beginGame() {
    this.setState({ startButtonStatus: "success", started: true });
    setTimeout(() => {
      document.getElementById("hello-text").className += " up";
    }, 200);

    setTimeout(() => {
      document.getElementById("hello-text").style.display = "none";
    }, 900);
  }

  selectGame(number) {
    console.log(number);
    this.setState({ gameNumber: number });
    setTimeout(() => {
      document.getElementById("game-menu").className += " up";
    }, 200);

    setTimeout(() => {
      document.getElementById("game-menu").style.display = "none";
    }, 900);
  }

  spinStatus(buttonNumber) {
    // if (buttonNumber === 1) {
    //   if (this.state.one === "wait") {
    //     this.setState({ one: "success" });
    //   }
    //   if (this.state.one === "success") {
    //     this.setState({ one: "wrong" });
    //   }
    //   if (this.state.one === "wrong") {
    //     this.setState({ one: "wait" });
    //   }
    // }
    // if (buttonNumber === 2) {
    //   if (this.state.two === "wait") {
    //     this.setState({ two: "success" });
    //   }
    //   if (this.state.two === "success") {
    //     this.setState({ two: "wrong" });
    //   }
    //   if (this.state.two === "wrong") {
    //     this.setState({ two: "wait" });
    //   }
    // }
    // if (buttonNumber === 3) {
    //   if (this.state.three === "wait") {
    //     this.setState({ three: "success" });
    //   }
    //   if (this.state.three === "success") {
    //     this.setState({ three: "wrong" });
    //   }
    //   if (this.state.three === "wrong") {
    //     this.setState({ three: "wait" });
    //   }
    // }
    if (buttonNumber === 1) {
      let d = this.state.dialogData;
      d.push({
        person: ["policeman", "you"],
        text: ["Пройдемте в отделение.", "Вы не имеете права!"]
      });
      this.setState({
        police: true,
        one: "success",
        two: "wrong",
        three: "wrong",
        dialogData: d
      });
      setTimeout(() => {
        document.getElementById('dialogList').scrollTop = 10000;
      }, 100)

    } else {
      this.setState({
        police: false,
        one: "success",
        two: "wrong",
        three: "wrong"
      });
    }
  }

  render() {
    return (
      <div className="window">
        <div id="hello-text" className="window__hello-text">
          <HelloText
            text={'Начать'}
            status={this.state.startButtonStatus}
            onClick={() => this.beginGame()} />
        </div>
        <div id="hello" className="window__hello">
          <Hello />
        </div>
        <div id="game-menu" className="window__game-menu">
          <GameMenu onClick={() => { this.selectGame() }} />
        </div>
        <div className="window__dialog">
          <Dialog dialogData={this.state.dialogData} jump={this.state.police} />
        </div>
        <div className="window__buttons">
          <Button
            onClick={() => this.spinStatus(1)}
            status={this.state.one}
            text="Показать документы"
          />
          <Button
            onClick={() => this.spinStatus(2)}
            status={this.state.two}
            text="Дать взятку"
          />
          <Button
            onClick={() => this.spinStatus(3)}
            status={this.state.three}
            text="Не показывать документы"
          />
        </div>
      </div>
    );
  }
}
